// import React, { useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { FaTimes } from "react-icons/fa";

// const PaymentModal = ({
//   isOpen,
//   onClose,
//   onConfirm,
//   fareData,
//   isPaying,
//   serType,
//   seatTotal,
//   ssrType,
//   setAmount,
//   userWallet,
//   totalPayableAmount,
//   onWalletPay,
//   isWalletProcessing, // ✅ NEW
// }) => {
//   if (!isOpen) return null;

//   // Check data structure
//   const isRoundTrip = fareData?.isRoundTrip || false;

//   let onwardBase = 0;
//   let onwardTax = 0;
//   let onwardTotal = 0;
//   let returnBase = 0;
//   let returnTax = 0;
//   let returnTotal = 0;
//   let combinedTotal = 0;

//   if (isRoundTrip) {
//     // Round trip structure
//     onwardBase = Number(
//       fareData?.selectedOnwardFare?.base ||
//         fareData?.onwardFlight?.Fare?.total?.netfare ||
//         0
//     );
//     onwardTax = Number(
//       fareData?.selectedOnwardFare?.tax ||
//         fareData?.onwardFlight?.Fare?.total?.tax ||
//         0
//     );
//     onwardTotal = Number(
//       fareData?.selectedOnwardFare?.price ||
//         fareData?.onwardFlight?.Fare?.total?.total ||
//         0
//     );

//     returnBase = Number(
//       fareData?.selectedReturnFare?.base ||
//         fareData?.returnFlight?.Fare?.total?.netfare ||
//         0
//     );
//     returnTax = Number(
//       fareData?.selectedReturnFare?.tax ||
//         fareData?.returnFlight?.Fare?.total?.tax ||
//         0
//     );
//     returnTotal = Number(
//       fareData?.selectedReturnFare?.price ||
//         fareData?.returnFlight?.Fare?.total?.total ||
//         0
//     );

//     combinedTotal = fareData?.totalPrice || onwardTotal + returnTotal;
//   } else {
//     // One-way flight structure - using the selectedFare data you provided
//     const selectedFare = fareData?.selectedFare || {};
//     onwardBase = Number(selectedFare.base || 0);
//     onwardTax = Number(selectedFare.tax || 0);
//     onwardTotal = Number(selectedFare.price || 0);
//     combinedTotal = onwardTotal;
//   }

//   const combinedBase = onwardBase + returnBase;
//   const combinedTax = onwardTax + returnTax;

//   // Calculate convenience fee based on service type
//   const markupRate = serType === 1 ? 0.01 : 0.005;
//   const computedAgentMarkup = Math.round(combinedTotal * markupRate);

//   const numericSeatTotal = Number(seatTotal || 0);
//   const effectiveSeatTotal = ssrType === "with" ? numericSeatTotal : 0;

//   // Calculate final amount
//   const finalAmount = combinedTotal + computedAgentMarkup + effectiveSeatTotal;

//   // Update parent amount
//   useEffect(() => {
//     if (typeof setAmount === "function") {
//       setAmount(finalAmount);
//     }
//   }, [finalAmount, setAmount]);

//   return (
//     <AnimatePresence>
//       <motion.div
//         className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//       >
//         <motion.div
//           className="bg-white rounded-2xl shadow-lg w-full max-w-md md:max-w-lg p-6 relative"
//           initial={{ y: 80, opacity: 0 }}
//           animate={{ y: 0, opacity: 1 }}
//           exit={{ y: 80, opacity: 0 }}
//         >
//           {/* Close Button */}
//           <button
//             onClick={onClose}
//             className="absolute top-3 right-3 text-gray-600 hover:text-gray-800"
//           >
//             <FaTimes size={18} />
//           </button>

//           {/* Header */}
//           <h2 className="text-xl md:text-2xl font-semibold text-center mb-4">
//             Payment Summary
//           </h2>

//           {/* Fare Details */}
//           <div className="space-y-3 text-gray-700">
//             {/* Convenience Fee */}
//             <div className="flex justify-between">
//               <span>Convenience Fee:</span>
//               <span>₹{computedAgentMarkup}</span>
//             </div>

//             {isRoundTrip ? (
//               <>
//                 {/* Onward Flight */}
//                 <div className="border-b pb-2 mb-2">
//                   <h3 className="font-medium text-blue-600 mb-1">
//                     Onward Flight
//                   </h3>
//                   <div className="flex justify-between text-sm">
//                     <span>Base Fare:</span>
//                     <span>₹{onwardBase}</span>
//                   </div>
//                   <div className="flex justify-between text-sm">
//                     <span>Tax & Fees:</span>
//                     <span>₹{onwardTax}</span>
//                   </div>
//                   <div className="flex justify-between text-sm font-medium">
//                     <span>Subtotal:</span>
//                     <span>₹{onwardTotal}</span>
//                   </div>
//                 </div>

//                 {/* Return Flight */}
//                 <div className="border-b pb-2 mb-2">
//                   <h3 className="font-medium text-blue-600 mb-1">
//                     Return Flight
//                   </h3>
//                   <div className="flex justify-between text-sm">
//                     <span>Base Fare:</span>
//                     <span>₹{returnBase}</span>
//                   </div>
//                   <div className="flex justify-between text-sm">
//                     <span>Tax & Fees:</span>
//                     <span>₹{returnTax}</span>
//                   </div>
//                   <div className="flex justify-between text-sm font-medium">
//                     <span>Subtotal:</span>
//                     <span>₹{returnTotal}</span>
//                   </div>
//                 </div>
//               </>
//             ) : (
//               /* One-way Flight */
//               <div className="border-b pb-2 mb-2">
//                 <h3 className="font-medium text-blue-600 mb-1">Flight Fare</h3>
//                 <div className="flex justify-between text-sm">
//                   <span>Base Fare:</span>
//                   <span>₹{onwardBase}</span>
//                 </div>
//                 <div className="flex justify-between text-sm">
//                   <span>Tax & Fees:</span>
//                   <span>₹{onwardTax}</span>
//                 </div>
//                 <div className="flex justify-between text-sm font-medium">
//                   <span>Subtotal:</span>
//                   <span>₹{onwardTotal}</span>
//                 </div>
//               </div>
//             )}

//             {/* Seat Cost */}
//             {effectiveSeatTotal > 0 && (
//               <div className="flex justify-between">
//                 <span>Seat Cost:</span>
//                 <span>₹{effectiveSeatTotal}</span>
//               </div>
//             )}

//             {/* Combined Totals for round trips */}
//             {isRoundTrip && (
//               <div className="border-t pt-2 mt-2">
//                 <div className="flex justify-between">
//                   <span>Total Base Fare:</span>
//                   <span>₹{combinedBase}</span>
//                 </div>
//                 <div className="flex justify-between">
//                   <span>Total Tax & Fees:</span>
//                   <span>₹{combinedTax}</span>
//                 </div>
//               </div>
//             )}

//             <hr className="my-2" />

//             {/* Final Total */}
//             <div className="flex justify-between font-semibold text-lg">
//               <span>Total Amount:</span>
//               <span className="text-green-600">₹{finalAmount}</span>
//             </div>
//           </div>

//           {/* Payment Actions */}
//           <div className="mt-6 space-y-3">
//             {/* Wallet NOT active */}
//             {userWallet === null && (
//               <div className="bg-yellow-100 text-yellow-800 p-3 rounded-lg text-sm">
//                 Please go to your profile and click on <b>Activate Wallet</b>.
//                 Our team will contact you to activate your wallet.
//               </div>
//             )}

//             {/* Wallet active but insufficient balance */}
//             {userWallet !== null && userWallet < totalPayableAmount && (
//               <div className="bg-red-100 text-red-700 p-3 rounded-lg text-sm">
//                 Your wallet balance is insufficient. Please go to your profile
//                 and send a request to admin to increase your wallet amount.
//               </div>
//             )}

//             {/* Wallet active and sufficient */}
//             {userWallet !== null && userWallet >= totalPayableAmount && (
//               <button
//                 onClick={onWalletPay}
//                 disabled={isWalletProcessing || isPaying}
//                 className={`w-full py-3 rounded-xl text-white ${
//                   isWalletProcessing || isPaying
//                     ? "bg-green-300 cursor-not-allowed"
//                     : "bg-green-600 hover:bg-green-700"
//                 }`}
//               >
//                 {isWalletProcessing
//                   ? "Processing Wallet Payment..."
//                   : `Pay ₹${totalPayableAmount} using Wallet`}
//               </button>
//             )}

//             {/* Razorpay section */}
//             <div className="flex flex-col sm:flex-row gap-3">
//               <button
//                 onClick={onClose}
//                 className="w-full sm:w-1/2 py-2.5 bg-gray-200 rounded-xl hover:bg-gray-300 text-gray-800"
//               >
//                 Cancel
//               </button>

//               <button
//                 onClick={onConfirm}
//                 disabled={isPaying || isWalletProcessing}
//                 className={`w-full sm:w-1/2 py-2.5 rounded-xl text-white ${
//                   isPaying || isWalletProcessing
//                     ? "bg-blue-400 cursor-not-allowed"
//                     : "bg-blue-600 hover:bg-blue-700"
//                 }`}
//               >
//                 {isPaying
//                   ? "Processing..."
//                   : isWalletProcessing
//                   ? "Wallet Payment in Progress..."
//                   : "Pay with Razorpay"}
//               </button>
//             </div>
//           </div>
//         </motion.div>
//       </motion.div>
//     </AnimatePresence>
//   );
// };

// export default PaymentModal;
import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaTimes } from "react-icons/fa";
import { CheckCircle, XCircle, AlertCircle, Clock } from "lucide-react";
import { useCurrency } from "../context/CurrencyContext";
import { formatPriceSync } from "../utils/currency";

const PaymentModal = ({
  isOpen,
  onClose,
  onConfirm,
  fareData,
  isPaying,
  serType,
  seatTotal,
  ssrType,
  setAmount,
  userWallet, // This should now be an object, not just balance
  totalPayableAmount,
  onWalletPay,
  isWalletProcessing,
}) => {
  const { currency } = useCurrency();
  if (!isOpen) return null;

  // Check data structure
  const isRoundTrip = fareData?.isRoundTrip || false;

  let onwardBase = 0;
  let onwardTax = 0;
  let onwardTotal = 0;
  let returnBase = 0;
  let returnTax = 0;
  let returnTotal = 0;
  let combinedTotal = 0;

  if (isRoundTrip) {
    // Round trip structure
    onwardBase = Number(
      fareData?.selectedOnwardFare?.base ||
        fareData?.onwardFlight?.Fare?.total?.netfare ||
        0
    );
    onwardTax = Number(
      fareData?.selectedOnwardFare?.tax ||
        fareData?.onwardFlight?.Fare?.total?.tax ||
        0
    );
    onwardTotal = Number(
      fareData?.selectedOnwardFare?.price ||
        fareData?.onwardFlight?.Fare?.total?.total ||
        0
    );

    returnBase = Number(
      fareData?.selectedReturnFare?.base ||
        fareData?.returnFlight?.Fare?.total?.netfare ||
        0
    );
    returnTax = Number(
      fareData?.selectedReturnFare?.tax ||
        fareData?.returnFlight?.Fare?.total?.tax ||
        0
    );
    returnTotal = Number(
      fareData?.selectedReturnFare?.price ||
        fareData?.returnFlight?.Fare?.total?.total ||
        0
    );

    combinedTotal = fareData?.totalPrice || onwardTotal + returnTotal;
  } else {
    // One-way flight structure
    const selectedFare = fareData?.selectedFare || {};
    onwardBase = Number(selectedFare.base || 0);
    onwardTax = Number(selectedFare.tax || 0);
    onwardTotal = Number(selectedFare.price || 0);
    combinedTotal = onwardTotal;
  }

  const combinedBase = onwardBase + returnBase;
  const combinedTax = onwardTax + returnTax;

  // Calculate convenience fee based on service type
  const markupRate = serType === 1 ? 0.01 : 0.005;
  const computedAgentMarkup = Math.round(combinedTotal * markupRate);

  const numericSeatTotal = Number(seatTotal || 0);
  const effectiveSeatTotal = ssrType === "with" ? numericSeatTotal : 0;

  // Calculate final amount
  const finalAmount = combinedTotal + computedAgentMarkup + effectiveSeatTotal;

  // Update parent amount
  useEffect(() => {
    if (typeof setAmount === "function") {
      setAmount(finalAmount);
    }
  }, [finalAmount, setAmount]);

  const getWalletStatus = () => {
    // DEBUG logging
    console.log("Checking wallet in PaymentModal:", userWallet);

    // If userWallet is a number (balance only)
    if (typeof userWallet === "number") {
      return {
        status: "active",
        message: "Wallet is active",
        canUseWallet: userWallet >= totalPayableAmount,
        balance: userWallet,
      };
    }

    // If userWallet is an object with isActive property
    if (userWallet && typeof userWallet === "object") {
      // Check for different possible property names
      const isActive =
        userWallet.isActive ||
        userWallet.active ||
        userWallet.status === "active" ||
        false;

      const balance =
        userWallet.balance ||
        userWallet.amount ||
        userWallet.currentBalance ||
        0;

      if (isActive) {
        return {
          status: "active",
          message: "Wallet is active and ready to use",
          canUseWallet: balance >= totalPayableAmount,
          balance: balance,
        };
      } else {
        return {
          status: "inactive",
          message: "Wallet is not active",
          canUseWallet: false,
          balance: balance,
        };
      }
    }

    // Default - wallet not activated
    return {
      status: "not_activated",
      message: "Wallet is not activated",
      canUseWallet: false,
      balance: 0,
    };
  };

  const walletStatus = getWalletStatus();

  // Get status badge component
  const StatusBadge = ({ status }) => {
    switch (status) {
      case "active":
        return (
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-green-100 text-green-800 text-sm font-medium">
            <CheckCircle className="w-4 h-4 mr-1" />
            Active
          </div>
        );
      case "pending":
        return (
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-yellow-100 text-yellow-800 text-sm font-medium">
            <Clock className="w-4 h-4 mr-1" />
            Pending
          </div>
        );
      case "deactivated":
        return (
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-red-100 text-red-800 text-sm font-medium">
            <XCircle className="w-4 h-4 mr-1" />
            Deactivated
          </div>
        );
      case "inactive":
        return (
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-gray-100 text-gray-800 text-sm font-medium">
            <AlertCircle className="w-4 h-4 mr-1" />
            Inactive
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          className="bg-white rounded-2xl shadow-lg w-full max-w-md md:max-w-lg p-6 relative"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-600 hover:text-gray-800"
          >
            <FaTimes size={18} />
          </button>

          {/* Header */}
          <h2 className="text-xl md:text-2xl font-semibold text-center mb-4">
            Payment Summary
          </h2>

          {/* Wallet Status Display - ADDED HERE */}
          <div className="mb-4 p-3 bg-gray-50 rounded-lg border border-gray-200">
            <div className="flex items-center justify-between mb-1">
              <span className="font-medium text-gray-700">Wallet Status:</span>
              <StatusBadge status={walletStatus.status} />
            </div>
            <div className="text-sm text-gray-600 mt-1">
              {walletStatus.message}
            </div>
            {walletStatus.status === "active" && (
              <div className="mt-2 flex justify-between items-center">
                <span className="text-sm text-gray-700">
                  Available Balance:
                </span>
                <span className="font-semibold text-green-600">
                  {formatPriceSync(walletStatus.balance, currency)}
                </span>
              </div>
            )}
          </div>

          {/* Fare Details */}
          <div className="space-y-3 text-gray-700">
            {/* Convenience Fee */}
            <div className="flex justify-between">
              <span>Convenience Fee:</span>
              <span>{formatPriceSync(computedAgentMarkup, currency)}</span>
            </div>

            {isRoundTrip ? (
              <>
                {/* Onward Flight */}
                <div className="border-b pb-2 mb-2">
                  <h3 className="font-medium text-blue-600 mb-1">
                    Onward Flight
                  </h3>
                  <div className="flex justify-between text-sm">
                    <span>Base Fare:</span>
                    <span>{formatPriceSync(onwardBase, currency)}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span>Tax & Fees:</span>
                    <span>{formatPriceSync(onwardTax, currency)}</span>
                  </div>
                  <div className="flex justify-between text-sm font-medium">
                    <span>Subtotal:</span>
                    <span>{formatPriceSync(onwardTotal, currency)}</span>
                  </div>
                </div>

                {/* Return Flight */}
                <div className="border-b pb-2 mb-2">
                  <h3 className="font-medium text-blue-600 mb-1">
                    Return Flight
                  </h3>
                  <div className="flex justify-between text-sm">
                    <span>Base Fare:</span>
                    <span>{formatPriceSync(returnBase, currency)}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span>Tax & Fees:</span>
                    <span>{formatPriceSync(returnTax, currency)}</span>
                  </div>
                  <div className="flex justify-between text-sm font-medium">
                    <span>Subtotal:</span>
                    <span>{formatPriceSync(returnTotal, currency)}</span>
                  </div>
                </div>
              </>
            ) : (
              /* One-way Flight */
              <div className="border-b pb-2 mb-2">
                <h3 className="font-medium text-blue-600 mb-1">Flight Fare</h3>
                <div className="flex justify-between text-sm">
                  <span>Base Fare:</span>
                  <span>{formatPriceSync(onwardBase, currency)}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span>Tax & Fees:</span>
                  <span>{formatPriceSync(onwardTax, currency)}</span>
                </div>
                <div className="flex justify-between text-sm font-medium">
                  <span>Subtotal:</span>
                  <span>{formatPriceSync(onwardTotal, currency)}</span>
                </div>
              </div>
            )}

            {/* Seat Cost */}
            {effectiveSeatTotal > 0 && (
              <div className="flex justify-between">
                <span>Seat Cost:</span>
                <span>{formatPriceSync(effectiveSeatTotal, currency)}</span>
              </div>
            )}

            {/* Combined Totals for round trips */}
            {isRoundTrip && (
              <div className="border-t pt-2 mt-2">
                <div className="flex justify-between">
                  <span>Total Base Fare:</span>
                  <span>{formatPriceSync(combinedBase, currency)}</span>
                </div>
                <div className="flex justify-between">
                  <span>Total Tax & Fees:</span>
                  <span>{formatPriceSync(combinedTax, currency)}</span>
                </div>
              </div>
            )}

            <hr className="my-2" />

            {/* Final Total */}
            <div className="flex justify-between font-semibold text-lg">
              <span>Total Amount:</span>
              <span className="text-green-600">{formatPriceSync(finalAmount, currency)}</span>
            </div>
          </div>

          {/* Payment Actions */}
          <div className="mt-6 space-y-3">
            {/* Wallet NOT active or insufficient */}
            {(!walletStatus.canUseWallet ||
              walletStatus.status !== "active") && (
              <div
                className={`p-3 rounded-lg text-sm ${
                  walletStatus.status === "pending"
                    ? "bg-yellow-100 text-yellow-800"
                    : walletStatus.status === "deactivated"
                    ? "bg-red-100 text-red-700"
                    : walletStatus.status === "inactive" ||
                      walletStatus.status === "not_activated"
                    ? "bg-blue-100 text-blue-800"
                    : walletStatus.balance < totalPayableAmount
                    ? "bg-orange-100 text-orange-800"
                    : "bg-gray-100 text-gray-800"
                }`}
              >
                {walletStatus.status === "not_activated" && (
                  <div>
                    <div className="font-medium mb-1">Wallet Not Activated</div>
                    <div>
                      Please go to your profile and click on{" "}
                      <b>Activate Wallet</b>. Our team will contact you to
                      activate your wallet.
                    </div>
                  </div>
                )}

                {walletStatus.status === "pending" && (
                  <div>
                    <div className="font-medium mb-1">
                      Wallet Activation Pending
                    </div>
                    <div>
                      Your wallet activation request is under review. You will
                      be notified once it's approved.
                    </div>
                  </div>
                )}

                {walletStatus.status === "deactivated" && (
                  <div>
                    <div className="font-medium mb-1">Wallet Deactivated</div>
                    <div>
                      Your wallet has been deactivated. Please go to your
                      profile to request reactivation.
                    </div>
                  </div>
                )}

                {walletStatus.status === "inactive" && (
                  <div>
                    <div className="font-medium mb-1">Wallet Inactive</div>
                    <div>
                      Please activate your wallet from your profile section to
                      use wallet payments.
                    </div>
                  </div>
                )}

                {walletStatus.status === "active" &&
                  walletStatus.balance < totalPayableAmount && (
                    <div>
                      <div className="font-medium mb-1">
                        Insufficient Wallet Balance
                      </div>
                      <div>
                        Your wallet balance (₹{walletStatus.balance}) is less
                        than total amount (₹{totalPayableAmount}). Please add
                        funds to your wallet.
                      </div>
                    </div>
                  )}
              </div>
            )}

            {/* Wallet active and sufficient */}
            {walletStatus.canUseWallet && (
              <button
                onClick={onWalletPay}
                disabled={isWalletProcessing || isPaying}
                className={`w-full py-3 rounded-xl text-white ${
                  isWalletProcessing || isPaying
                    ? "bg-green-300 cursor-not-allowed"
                    : "bg-green-600 hover:bg-green-700"
                }`}
              >
                {isWalletProcessing
                  ? "Processing Wallet Payment..."
                  : `Pay ${formatPriceSync(totalPayableAmount, currency)} using Wallet`}
              </button>
            )}

            {/* Razorpay section */}
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={onClose}
                className="w-full sm:w-1/2 py-2.5 bg-gray-200 rounded-xl hover:bg-gray-300 text-gray-800"
              >
                Cancel
              </button>

              <button
                onClick={onConfirm}
                disabled={isPaying || isWalletProcessing}
                className={`w-full sm:w-1/2 py-2.5 rounded-xl text-white ${
                  isPaying || isWalletProcessing
                    ? "bg-blue-400 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700"
                }`}
              >
                {isPaying
                  ? "Processing..."
                  : isWalletProcessing
                  ? "Wallet Payment in Progress..."
                  : "Pay with Razorpay"}
              </button>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default PaymentModal;
